import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ReloadState {
  carUpdateReload: boolean;
  staffReload: boolean;
  customersReload: boolean;
  conversationsReload: boolean;
  moneyRequestReload: boolean;
}

const initialState: ReloadState = {
  carUpdateReload: false,
  staffReload: false,
  customersReload: false,
  conversationsReload: false,
  moneyRequestReload: false,
};

export const reload = createSlice({
  name: "reload",
  initialState,
  reducers: {
    setCarUpdateReload: (state, action: PayloadAction<boolean>) => {
      state.carUpdateReload = action.payload;
    },
    setStaffReload: (state, action: PayloadAction<boolean>) => {
      state.staffReload = action.payload;
    },
    setCustomersReload: (state, action: PayloadAction<boolean>) => {
      state.customersReload = action.payload;
    },
    setConversationsReload: (state, action: PayloadAction<boolean>) => {
      state.conversationsReload = action.payload;
    },
    setMoneyRequestReload: (state, action: PayloadAction<boolean>) => {
      state.moneyRequestReload = action.payload;
    },
  },
});

export const {
  setCarUpdateReload,
  setStaffReload,
  setCustomersReload,
  setConversationsReload,
  setMoneyRequestReload,
} = reload.actions;

export default reload.reducer;
